import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

type RedeemDetailSetData = {
  redeemModifiedText: string;
};

const initialState: RedeemDetailSetData = {
  redeemModifiedText: "",
};

const redeemDetailSlice = createSlice({
  name: "redeemDetail",
  initialState,
  reducers: {
    setModifiedTextData: (state: RedeemDetailSetData, action: PayloadAction<RedeemDetailSetData>) => ({
      ...state,
      ...{
        redeemModifiedText: action.payload.redeemModifiedText ?? state.redeemModifiedText,
      },
    }),
  },
});

export const { setModifiedTextData } = redeemDetailSlice.actions;

export default redeemDetailSlice.reducer;
